import { useContext } from 'react';
import { CostDataContext } from '../contexts/CostDataProvider';

const useCostData = () => (
  useContext(CostDataContext)
);

export default useCostData;
